export const validators: Record<string, string> = {
    int: '\\d{6}$|^110$|^112$|^113$|^911$',
    '+47': '^\\d{8}$|^110$|^112$|^113$|^911$',
    '+45': '^\\d{8}$|^110$|^112$|^113$|^911$',
    '+46': '^[0]{0,1}[1-9]{1,3}[-]{0,1}\\d{6,9}$|^110$|^112$|^113$|^911$',
    '+44': '^0\\d{9,10}|0\\d{7}|\\(0\\d{2,5}\\)\\d{4,8}$|^110$|^112$|^113$|^911$',
}

export const favoriteCountries: Record<string, string> = {
    NO: '+47',
    SE: '+46',
    DK: '+45',
    GB: '+44',
}

export const countries: Record<string, string> = {
    AD: '+376',
    AL: '+355',
    AM: '+374',
    AT: '+43',
    AU: '+43',
    AZ: '+994',
    BA: '+387',
    BE: '+32',
    BG: '+359',
    BY: '+375',
    CA: '+1',
    CH: '+41',
    CL: '+56',
    CN: '+86',
    CS: '+381',
    CY: '+357',
    CZ: '+420',
    DE: '+49',
    EE: '+372',
    ES: '+34',
    FI: '+358',
    FO: '+298',
    FR: '+33',
    GE: '+995',
    GI: '+350',
    GL: '+299',
    GR: '+30',
    HR: '+385',
    HU: '+36',
    IE: '+353',
    IL: '+972',
    IS: '+354',
    IT: '+39',
    JP: '+81',
    KR: '+82',
    LB: '+961',
    LI: '+423',
    LT: '+370',
    LU: '+352',
    LV: '+371',
    MC: '+355',
    MD: '+373',
    MK: '+389',
    MT: '+356',
    MY: '+60',
    NL: '+31',
    NZ: '+64',
    PL: '+48',
    PT: '+351',
    RO: '+40',
    RU: '+7',
    SI: '+386',
    SK: '+421',
    TR: '+90',
    UA: '+380',
    US: '+1',
    VN: '+84',
    TH: '+66',
}

export const allCountries: Record<string, string> = { ...favoriteCountries, ...countries }
